import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import React, { Component } from 'react';
import { window } from '../../helpers/BrowserHelpers';
var IGNORED_OPERATION = ['set_value'];

var SliteEditorError =
/*#__PURE__*/
function (_Error) {
  _inherits(SliteEditorError, _Error);

  function SliteEditorError(error) {
    var _this;

    _classCallCheck(this, SliteEditorError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SliteEditorError).call(this, error));
    _this.name = 'SliteEditorError';
    _this.code = error.code;
    _this.stack = error.stack;
    _this.message = "".concat(error.name, ": ").concat(error.message);
    _this.originalError = error;
    return _this;
  }

  _createClass(SliteEditorError, [{
    key: "isRecoverable",
    value: function isRecoverable() {
      switch (this.originalError.message) {
        case 'Invalid attempt to destructure non-iterable instance':
          return true;

        default:
          return false;
      }
    }
  }]);

  return SliteEditorError;
}(_wrapNativeSuper(Error));

var SliteEditorErrorContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(SliteEditorErrorContainer, _Component);

  function SliteEditorErrorContainer() {
    _classCallCheck(this, SliteEditorErrorContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(SliteEditorErrorContainer).apply(this, arguments));
  }

  _createClass(SliteEditorErrorContainer, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      this.props.editor.run('onError', error);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return SliteEditorErrorContainer;
}(Component);

var BUGSNAG_BREADCRUMB_TITLE = 'Slite Editor Operation';
var SAVE_COMMAND = 'save';
export default (function () {
  return [{
    commands: {
      addBreadcrumb: function addBreadcrumb(editor, rawData) {
        var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : BUGSNAG_BREADCRUMB_TITLE;
        if (!window.bugsnag) return;
        var data = Object.entries(rawData).reduce(function (memo, _ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              possibleObject = _ref2[1];

          memo[key] = JSON.stringify(possibleObject);
          return memo;
        }, {});
        window.bugsnag.leaveBreadcrumb(title, data);
      }
    },
    onConstruct: function onConstruct(editor, next) {
      if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        window.editor = editor;
      }

      window.testSliteEditorError = function () {
        editor.run('onError', new Error('Testing SliteEditorError'));
      };

      return next();
    },
    onError: function onError(originalError, editor, next) {
      var error = new SliteEditorError(originalError);

      if (error.isRecoverable()) {
        console.error(error);
        return;
      }

      return next(error);
    },
    onChange: function onChange(editor, next) {
      try {
        return next();
      } catch (error) {
        editor.run('onError', error);
      }
    },
    onCommand: function onCommand(command, editor, next) {
      try {
        if (command.type === SAVE_COMMAND && window.bugsnag) {
          var operation = command.args[0];

          if (!IGNORED_OPERATION.includes(operation.type)) {
            editor.addBreadcrumb(operation.toJSON());
          }
        }

        return next();
      } catch (error) {
        editor.run('onError', error);
      }
    },
    renderEditor: function renderEditor(props, editor, next) {
      return React.createElement(SliteEditorErrorContainer, {
        editor: editor
      }, next());
    }
  }];
});